<script>
export default {
  name: "WFLine"
}
</script>

<template>
  <div class="w-f-line"></div>
</template>

<style scoped lang="scss">
.w-f-line {
  height: 100%;
  width: 1px;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    background-color: #838383;
    top: 15%;
    left: 0;
    height: 70%;
    width: 1px;
  }
}
</style>